
import { computed, defineComponent, onBeforeUnmount, onMounted, ref } from 'vue'
import { getThisMonthStartTime, getThisWeekStartTime, getThisYearStartTime, getTodayNowTime, getTodayStartTime } from '@/utils/date.util';
import OpenTicketReportApi from '@/api/OpenTicketReportApi';

export default defineComponent({
  setup () {
    let timer = 0
    const max = ref(0)
    const rankList = ref<any []>([])
    const timeRef = ref<string>('THIS_DAY')
    const timeMap = new Map([
      ['THIS_DAY', '今日'],
      ['THIS_WEEK', '本周'],
      ['THIS_MONTH', '本月'],
      ['THIS_YEAR', '本年']
    ])
    const timeFilter = computed(() => {
      return (value) => {
        return timeMap.get(value + '')
      }
    })
    function statisticsServiceCatalogTicket () {
      let startDate: string | null = null
      const endDate: string | null = getTodayNowTime()
      if (timeRef.value === 'THIS_DAY') {
        startDate = getTodayStartTime()
      } else if (timeRef.value === 'THIS_WEEK') {
        startDate = getThisWeekStartTime()
      } else if (timeRef.value === 'THIS_MONTH') {
        startDate = getThisMonthStartTime()
      } else if (timeRef.value === 'THIS_YEAR') {
        startDate = getThisYearStartTime()
      }
      OpenTicketReportApi.statisticsServiceCatalogTicket({
        startDate,
        endDate,
        page: {
          pageNumber: 1,
          pageSize: 100
        }
      }).then((res:any) => {
        rankList.value = res.list.slice(0, 5)
        max.value = res.list.length > 0 ? rankList.value[0].count : 0
        timer = setTimeout(() => {
          statisticsServiceCatalogTicket()
        }, 10000);
      })
    }

    function setTime (status: string) {
      timeRef.value = status
      timer && clearTimeout(timer)
      statisticsServiceCatalogTicket()
    }

    onMounted(() => {
      statisticsServiceCatalogTicket()
    })
    
    onBeforeUnmount(() => {
      clearTimeout(timer)
    })

    return {
      timeRef,
      max,
      rankList,
      timeFilter,
      setTime
    }
  }
})
